import React, { useEffect } from 'react';
import './styles.css';
import { ECE, ADMIN } from '@BUP/constants';
import { useHistory, useLocation } from "react-router-dom";
import { PageLayout, ChatBox } from '@BUP/components';
import { Breadcrumb, Tooltip, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useChatbox, useAuth } from '@BUP/hooks';
import { isRoleAllowed } from '@BUP/services/BraveUp';

const BupDirectPage = () => {
  const { user } = useAuth();
  const userRole = user?.roles?.type;
  const history = useHistory();
  const {
    prevLocation,
    mainMessage,
    messageCreator
  } = useLocation();
  const {
    messages,
    isLoading,
    handleSendMessage,
    chatContainerRef,
    fatherMessage,
    isCaseOpen,
    openMainMessage
  } = useChatbox(mainMessage);


  useEffect(() => {
    if (!fatherMessage) {
      history.push(prevLocation ? prevLocation : '/modebup/inbox');
    }
  }, [fatherMessage]);

  return (
    <PageLayout>
      <div className="direct-message-page-container">
        <div className="title-container">
          <Tooltip title="Volver">
            <Button
              className="circle-back-button"
              shape="circle"
              icon={<ArrowLeftOutlined />}
              onClick={() => history.goBack()}
            />
          </Tooltip>
          <Breadcrumb separator=">" className="modebup-breadcrumb">
            <Breadcrumb.Item>MODO BUP!</Breadcrumb.Item>
            <Breadcrumb.Item
              className="navigate"
              onClick={() =>
                history.push(
                  isRoleAllowed(userRole, [ECE, ADMIN]) ?
                    isCaseOpen ? '/modebup/inbox' : '/modebup/archived'
                    : '/modebup/inbox'
                )
              }
            >
              {
                isRoleAllowed(userRole, [ECE, ADMIN]) ?
                  isCaseOpen ? "BANDEJA DE ENTRADA" : "CASOS ARCHIVADOS"
                  : "BANDEJA DE ENTRADA"
              }
            </Breadcrumb.Item>
            <Breadcrumb.Item>MENSAJE</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <ChatBox
          mainMessage={mainMessage}
          messageCreator={messageCreator}
          isCaseOpen={isCaseOpen}
          onOpenMainMessage={openMainMessage}
          messages={messages}
          isLoading={isLoading}
          onSendMessage={handleSendMessage}
          chatContainerRef={chatContainerRef}
          fatherMessage={fatherMessage}
        />
      </div>
    </PageLayout>
  )
}

export default BupDirectPage;